// libs
import React from 'react';
import c from 'classnames';
import range from 'lodash/range';

// components
import Stack from '../../Stack';
// types
import { NumberRatingProps } from '..';
import useLayouts from './hooks/useLayouts';
import NumberRatingItem from './NumberRatingItem';

const NumberRating = (props: NumberRatingProps) => {
  const { className = '', max = 5, onChange, value } = props;
  const { containerLayout, itemLayout, onLayoutContainer, onLayoutItem } = useLayouts();
  return (
    <Stack alignItems="center" className={className} onLayout={onLayoutContainer}>
      {range(1, max + 1).map((rating, index, arr) => (
        <NumberRatingItem
          key={rating}
          className={c(
            // space-x style does not work with native :(
            { 'me-12': index !== arr.length - 1 },
            // space-y style does not work with native :(
            {
              'mb-8':
                containerLayout?.width < itemLayout?.width * max &&
                Math.round(containerLayout?.width / (itemLayout?.width ?? 1)) < index + 1,
            },
          )}
          selected={rating === value}
          value={rating}
          onChange={onChange}
          onLayout={onLayoutItem}
        />
      ))}
    </Stack>
  );
};

export default React.memo(NumberRating);
